import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ProfessioneSanitaQuotesStyles, RiskContainer } from './styles/ProfessionaleSanitaStyles.styles';
import {
  addProfessioneSanitariaQuoteToCart, professioniSanitaQuotesGetQuotes, professioniSanitaSilentQuotesGetQuotes, removeProfessioniSanitaQuoteFromCart,
} from '../../features/insuranceRequests/insuranceRequestsActions';
import ErrorComponent from '../../common/components/ErrorComponent';
import ProfessioneSanitaModalButtons from './components/ProfessioneSanitaModalButtons';
import ProfessioneSanitaModal from './components/ProfessioneSanitaModal';
import { confirmAlert, generalAlertError } from '../../common/utils/alerts';
import PageLoading from '../../common/componentsV2/elements/PageLoading';
import ConversationModal from '../../common/components/redesignComponents/Modal/ConversationModal';
import { EstimateContainer } from '../../common/components/redesignComponents/common/Redesign.styles';
import { primaQuoteTypes } from '../../common/constants';
import { V2FontImport } from '../../common/formInputsV2/V2Fonts';
import ResultOverviewRow from '../../common/components/redesignComponents/ResultPageComponents/v2/ResultOverviewRow';
import RcProfessionaleSanitaSummaryCard from '../../common/components/redesignComponents/ResultPageComponents/v2/RcProfessionaleSanitaSummaryCard';
import QuoteCostSummaryCard from '../../common/components/redesignComponents/ResultPageComponents/v2/QuoteCostSummaryCard';
import {
  OutlineActionButton,
  ActionButtonBadge,
} from '../../common/components/redesignComponents/ResultPageComponents/v2/SecondaryActionButtons.styles';
import { ChatIcon } from '../../common/components/redesignComponents/ResultPageComponents/v2/ActionIcons';
import FailedQuotationsComponent from '../../common/components/redesignComponents/ResultPageComponents/v2/FailedQuotationsComponent';

function ProfessioneSanitaQuotes() {
  const { requestToken } = useParams();
  const navigate = useNavigate();
  const {
    loading,
    error,
    insuranceRequest,
    customer,
    quotations,
    addingQuote,
    processingQuote,
    failedQuotes,
    riskQuotations,
    thread,
    est_provvigioni,
  } = useSelector((store) => store.insuranceRequests.professioni_sanita);
  const [showConversationModal, setShowConversationModal] = useState(false);
  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);

  const refresh = () => professioniSanitaQuotesGetQuotes(requestToken);

  const silentRefresh = () => professioniSanitaSilentQuotesGetQuotes(requestToken);

  const getCorrectParamForRoute = (subProduct) => {
    if (subProduct === 'medici_liberi_professionisti') {
      return 'medici-liberi-professionisti';
    }
    if (subProduct === 'professioni_sanitarie') {
      return 'professioni-sanitarie';
    }
    if (subProduct === 'medici_dipendenti') {
      return 'medici-dipendenti';
    }
    if (subProduct === 'medico_protetto') {
      return 'medico-protetto';
    }
    return '';
  };

  const modifyData = () => {
    let sub_product = null;
    if (processingQuote !== null) {
      sub_product = processingQuote.sub_product;
    } else if (quotations && quotations.res_civile) {
      const resCivile = quotations.res_civile[0];
      sub_product = resCivile.sub_product;
    }
    if (sub_product !== null) {
      navigate(`/quote/rc-professionale-sanita/${getCorrectParamForRoute(sub_product)}`, {
        state: { requestToken },
      });
    } else {
      navigate('/quote/rc-professionale-sanita');
    }
  };

  const selectQuotation = (quoteId, closeButton) => {
    confirmAlert('Sei Sicuro di aggiungere questa quotazione?', () => addProfessioneSanitariaQuoteToCart(quoteId, refresh, modifyData, closeButton));
  };

  const removeItemFromCart = (quoteId) => {
    confirmAlert('Sei Sicuro di rimuovere questa quotazione?', () => removeProfessioniSanitaQuoteFromCart(quoteId, refresh, modifyData));
  };

  const handleRequestPurchase = () => {
    if (processingQuote === null) {
      generalAlertError('Seleziona Prima La Responsabilita Civile', 'Errore');
      return;
    }

    navigate(`/quotes/rc-professionale-sanita/purchase/${requestToken}`);
  };

  useEffect(() => {
    refresh();
  }, [requestToken]);

  const getTotal = () => {
    let quoteInProccessAmount = 0;
    let risksTotalAmount = 0;

    if (processingQuote !== null && processingQuote.amount !== null) {
      quoteInProccessAmount = parseFloat(processingQuote.amount);
    }

    const riskTypes = quoteTypes.filter((t) => t.id !== 'res_civile');

    for (let x = 0; x < riskTypes.length; x++) {
      const type = riskTypes[x];
      if (riskQuotations && riskQuotations[type.id] !== undefined) {
        for (let i = 0; i < riskQuotations[type.id].length; i++) {
          const item = riskQuotations[type.id][i];

          risksTotalAmount += parseFloat(item.amount);
        }
      }
    }

    return (quoteInProccessAmount + risksTotalAmount).toFixed(2);
  };

  // useEffect(() => {
  //   if (loading === false && insuranceRequest.is_expired === true && insuranceRequest.request_token === requestToken) {
  //     navigate('/quote/rc-professionale-sanita', {
  //       state: { requestToken: insuranceRequest.request_token },
  //     });
  //     generalAlertError(
  //       'È necessario compilare nuovamente il preventivo!',
  //       'Link e scaduto!',
  //     );
  //   }
  // }, [loading, insuranceRequest, requestToken]);

  if (loading) {
    return <PageLoading />;
  }

  if (error !== null) {
    return <ErrorComponent error={error} />;
  }

  return (
    <>
      {showConversationModal && (
        <ConversationModal
          requestId={insuranceRequest?.id}
          threadId={thread?.thread_id}
          onClose={() => {
            setShowConversationModal(false);
            silentRefresh();
          }}
          onUpdated={() => silentRefresh()}
          location="quotation_professioni_sanitarie_result"
        />
      )}
      <V2FontImport />
      <ProfessioneSanitaQuotesStyles>
        <div className="resultsPage">
          <ResultOverviewRow>
            <RcProfessionaleSanitaSummaryCard
              customer={customer}
              insuranceRequest={insuranceRequest}
              modifyData={modifyData}
            />
            <QuoteCostSummaryCard
              processingQuote={processingQuote}
              quoteTypes={quoteTypes}
              riskQuotations={riskQuotations}
              primaQuoteTypes={primaQuoteTypes}
              getTotal={getTotal}
              onProcedi={() => handleRequestPurchase()}
              rcTypeLabel={processingQuote?.product_name}
              est_provvigioni={est_provvigioni}
            />
          </ResultOverviewRow>
          <div className="row">
            <div className="col-12 ">
              <EstimateContainer>
                <div className="d-flex gap-2 justify-content-end ">
                  <div>
                    {/* {localStorage.getItem('quoteNewResult') === 'done' && (
                      <div style={{ cursor: 'pointer' }} onClick={() => firePurchaseTour()}>
                        <button className="btn btn-success px-2 py-1">Tutorial</button>
                      </div>
                    )} */}
                    <OutlineActionButton
                      type="button"
                      onClick={() => {
                        setShowConversationModal(true);
                        if (thread?.unreadMessages > 0) silentRefresh();
                      }}
                    >
                      <ChatIcon />
                      Contatta il Backoffice
                      {thread?.unreadMessages > 0 && (
                        <ActionButtonBadge>
                          {thread.unreadMessages}
                          <span className="visually-hidden">messaggi non letti</span>
                        </ActionButtonBadge>
                      )}
                    </OutlineActionButton>
                  </div>
                </div>
              </EstimateContainer>
            </div>
          </div>

          {quotations && !quotations.res_civile
            && (
              <div className="alert alert-info mx-2" role="alert">
                <h4 className="alert-heading">Avviso!</h4>
                <p className="m-0">Il preventivo non è riuscito per problemi relativi ai dati assicurativi. Si prega di contattare il nostro backoffice per ottenere il preventivo o ulteriori informazioni.</p>
              </div>
            )}

          {quotations && quotations.res_civile
            && (
              <>
                <RiskContainer className="mb-3 pb-3 result-home-third-step">
                  {quoteTypes.map((type, index) => (
                    <React.Fragment key={index}>
                      {quotations && quotations[type.id] && (
                        <ProfessioneSanitaModalButtons
                          insuranceRequest={insuranceRequest}
                          processingQuote={processingQuote}
                          type={type}
                          removeItemFromCart={removeItemFromCart}
                          riskQuotations={riskQuotations}
                        />
                      )}
                    </React.Fragment>
                  ))}
                </RiskContainer>

                {quoteTypes.map((type, index) => (
                  <ProfessioneSanitaModal
                    insuranceRequest={insuranceRequest}
                    type={type}
                    key={index}
                    addingQuote={addingQuote}
                    quotations={quotations}
                    selectQuotation={selectQuotation}
                    processingQuote={processingQuote}
                  />
                ))}
              </>
            )}
        </div>

        {failedQuotes !== null && failedQuotes.length > 0 && (
          <FailedQuotationsComponent failedQuotes={failedQuotes} />
        )}
      </ProfessioneSanitaQuotesStyles>
    </>
  );
}

export default ProfessioneSanitaQuotes;
